import { BackofficeIntegration } from '@alquilatucancha/backoffice-integration';
import angular from 'angular';
import common from './core.module';
import _ from 'lodash';
import toastrConfig from "./config/toastr";
import loadingBarConfig from "./config/loading-bar";
import analyticsConfig from "./config/analytics-config";
import errorHandlers from "./config/error-handlers";
import setGlobalState from "./bootstrap/set-global-state";
import onlineChecker from "./bootstrap/online-checker";
import overrideDatePickerTemplates from "./bootstrap/override-date-picker-template";
import LoadTemplates from "./bootstrap/load-templates";
import ConfigureXeditable from './config/xeditable';

const backoffice = new BackofficeIntegration({
    base_url: window._backoffice_config.base_url,
    sportclub_id: window._backoffice_config.sportclub_id,
    currency: window._backoffice_config.currency,
    locale: window._backoffice_config.locale,
    storage: window.localStorage,
    environment: window._backoffice_config.environment,
    public_base_url: window._backoffice_config.public_base_url
});
window._backoffice = backoffice;

setInterval(() => {
    if (!backoffice.is_logged_in && !window.location.hash.includes('login/signin')) {
        window.location.reload();
        return;
    }
}, 60_000);

const moduleName = 'atc-config';
angular.module(moduleName, [common])
    .constant('_', _)
    .constant('Backoffice', backoffice)
    .constant('disabled_features', window.disabled_features?.split(",") || [])
    .constant('APP_MEDIAQUERY', {
        'desktopXL': 1200,
        'desktop': 992,
        'tablet': 768,
        'mobile': 480
    })
    .constant('paymentTypes', ['cash','credit_card','debit_card','mercado_pago','check','transfer'])
    .constant('serverDateTimeFormat', 'Y-MM-DD HH:mm')
    .constant('ENV', process.env.NODE_ENV)
    .constant('DEBUG_MODE', process.env.DEBUG === 'true')
    .config(toastrConfig)
    .config(loadingBarConfig)
    .config(analyticsConfig)
    .config(errorHandlers.promises)
    .config(errorHandlers.analytics)
    .run(LoadTemplates)
    .run(setGlobalState)
    .run(onlineChecker)
    .run(ConfigureXeditable)
    .run(overrideDatePickerTemplates)
;


export default moduleName;
